import { render } from "./SectionRowInfo.vue?vue&type=template&id=4841a746&scoped=true"
import script from "./SectionRowInfo.vue?vue&type=script&lang=js"
export * from "./SectionRowInfo.vue?vue&type=script&lang=js"

import "./SectionRowInfo.vue?vue&type=style&index=0&id=4841a746&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4841a746"]])

export default __exports__